module.exports = __webpack_public_path__ + "img/DpMagqPr.076ec82a.svg";